import api from "../api/axiosConfig";

export const getProducts = async () => {
  const response = await api.get("/product");
  return response.data;
};

export const getBestSellerProducts = async () => {
    const response = await api.get("/bestseller");
    return response.data;
};

export const getVideoBanner = async () => {
    const response = await api.get("/video-banner");
    return response.data;
};

export const getCollectionBanner = async () => {
    const response = await api.get("/collection-banner");
    return response.data;
};

export const getValueComboProducts = async () => {
    const response = await api.get("/value-combos");
    return response.data;
};

export const getPromoVideoBanner = async () => {
    const response = await api.get("/promo-video-banner");
    return response.data;
};

export const getAboutFarmFox = async () => {
    const response = await api.get("/about-farmfox");
    return response.data;
};

export const getBrandPromiseBanner = async () => {
    const response = await api.get("/brand-promise-banner");
    return response.data;
};

export const getBlogs = async () => {
    const response = await api.get("/blogs");
    return response.data;
};

export const getBlogsByCategory = async (category) => {
    const response = await api.get(
        `/blogs/category/${category}`
    );
    return response.data;
};

export const getFaqs = async () => {
    const response = await api.get("/faqs");
    return response.data;
};

export const getRecommendedProducts = async () => {
    const response = await api.get("/recommended-products");
    return response.data;
};

export const getSeoContent = async () => {
    const response = await api.get("/seo-content");
    return response.data;
};

export const getMediaTalks = async () => {
    const response = await api.get("/media-talks");
    return response.data;
};